import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "../../tailwind.config.js";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { formatValue } from "../../components/Utils.js";
import AggregatedTable from "../../components/AggregatedTable.jsx";
import { SparkBar } from "../../components/chart-components/SparkBar.jsx";
import Tooltip from "../../components/form-components/Tooltip.jsx";

const colors = resolveConfig(tailwindConfig).theme.colors;

const UntaggedTransactionsAggregates = (props) => {
	const data = props.data;
	const sortTable = props.sortTable;
	const sortColumn = props.sortColumn;
	const addMoreCostDetails = props.addMoreCostDetails;
	const limit = props.limit;
	const totalCost = props.totalCost;

	const calculatePercentage = (value, total, decimals = 2) => {
		if (total === 0) return 0;
		return ((value / total) * 100).toFixed(decimals);
	};

	function toggleRow(grouping) {
        const openResourceTypes = sessionStorage.getItem('openUntaggedTransactionsAggregates');

        let openRows = openResourceTypes ? openResourceTypes.split(",") : [];

        const index = openRows.indexOf(String(grouping));

        if (index > -1) {
			openRows = openRows.filter((row) => row !== String(grouping));
		} else {
			openRows = [...openRows, String(grouping)];
		}

        sessionStorage.setItem('openUntaggedTransactionsAggregates', openRows.join(","));
	}

	const getClassNamesMeasures = (row) => {
		let classNames = "";

		if (row.row.original.cost_component) {
			classNames = "text-left text-text font-xs font-regular";
		} else {
			classNames = "text-left text-text font-semibold";
		}

		return classNames;
	}


	const columnDefs = [
		{
			accessor: "plus",
			id: "expander",
			Header: (row) => <div className=""><span data-tooltip-id="instantTooltip" data-tooltip-content="The cost component that has not been tagged">Cost Component</span></div>,
			Cell: ({ row }) => {
				const toggleRowExpandedProps = row.getToggleRowExpandedProps();
				const onClick = async (event) => {
					toggleRowExpandedProps.onClick(event);

					if (toggleRow) toggleRow(row.original.resource_type);
					// if (!row.isExpanded && !row.original.subRows) {
						// retrieveAssets(row.original.resource_type);
					// }
				};

				const margin = {
                    paddingLeft: 36 + ((row.depth-1)*36)
                }

				if (row.depth <= 1) {
					if (row.original.subRows && row.original.subRows.length > 0) {
						return (
								<span {...row.getToggleRowExpandedProps()} onClick={onClick} style={margin} className="text-left text-text font-semibold cursor-pointer">
									{row.isExpanded ? (
										<FontAwesomeIcon
											icon={icon({
												name: "angle-down",
												family: "sharp",
												style: "solid",
											})}
											className="text-text-2 mr-2"
										/>
									) : (
										<FontAwesomeIcon
											icon={icon({
												name: "angle-right",
												family: "sharp",
												style: "solid",
											})}
											className="text-text-2 mr-2"
										/>
									)}
									{row.depth === 0 ? row.original.cost_resource_cluster : row.original.cost_resource_type}
								</span>
						);
					}
				} else {
					return (
						<div style={margin}className="pl-12 text-sm">
							{row.original.cost_component}
						</div>
					)
				}
			},
			minWidth: 300,
			width: 300,
			maxWidth: 300,
		},
		{
			accessor: "perc_total_transactions",
			Header: (row) => (
				<div
					className="cursor-pointer"
				>
					<span data-tooltip-id="instantTooltip" data-tooltip-content="The percentage of the total untagged cost">% Untagged cost</span>
				</div>
			),
			Cell: (cell) => (
					<div className={getClassNamesMeasures(cell)}>
						{/* {calculatePercentage(row.row.original.untagged_cost, totalCost, 0)}% */}
						<SparkBar 
						data={cell.row.original.untagged_cost/totalCost*100} 
						barColor={cell.row.depth === 0 ? "hsl(var(--chart-1))" : cell.row.depth === 1 ? colors.red10 : colors.coolgrey8}
						// onClick={(e) => { openDetails(row.row.original.product_id)} }
						maxValue={100}
						totalValue={100}
						format="percentage"
						decimals={1}
					/>
				</div>
			),
			width: 100,
		},
        {
			accessor: "untagged_cost",
			Header: (row) => (
				<div
					className="cursor-pointer"
				>
					<span data-tooltip-id="instantTooltip" data-tooltip-content="The cost of the resource that has not been tagged">Untagged cost</span>
				</div>
			),
			Cell: (row) => (
				<div className={getClassNamesMeasures(row)}>
					{formatValue(row.value, "currency", false)}
				</div>
			),
			width: 100,
		},

		{
			accessor: "perc_untagged_cost",
			Header: (row) => (
				<div
					className="cursor-pointer"
				>
					<span data-tooltip-id="instantTooltip" data-tooltip-content="The percentage of the total untagged cost">% Untagged cost</span>
				</div>
			),
			Cell: (cell) => (
				<div className={getClassNamesMeasures(cell)}>
					{/* {calculatePercentage(row.row.original.untagged_cost, totalCost, 0)}% */}
					<SparkBar 
						data={calculatePercentage(cell.row.original.untagged_cost,cell.row.original.total_cost)} 
						barColor={cell.row.depth === 0 ? "hsl(var(--chart-1))" : cell.row.depth === 1 ? colors.red10 : colors.coolgrey8}
						// onClick={(e) => { openDetails(row.row.original.product_id)} }
						maxValue={100}
						totalValue={100}
						format="percentage"
						decimals={1}
					/>
				</div>
			),
			width: 100,
		},
		{
			accessor: "total_cost",
			Header: (row) => (
				<div
					className="cursor-pointer"
				>
					<span data-tooltip-id="instantTooltip" data-tooltip-content="The total cost of the resource">Total cost</span>
				</div>
			),
			Cell: (row) => (
				<div className={getClassNamesMeasures(row)}>
					{formatValue(row.value, "currency", false)}
				</div>
			),
			width: 100,
		},
	];

	return (
		<Fragment>
			<Tooltip />
			<AggregatedTable
				data={data}
				expandAll={true}
				sortColumn={sortColumn}
				sortTable={sortTable}
				retrieveData={addMoreCostDetails}
				limit={limit}
				columnDefs={columnDefs}
			/>
		</Fragment>
	);
};

export default UntaggedTransactionsAggregates;
